import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { useTheme } from '../../ThemeContext';

import Modal from '../Modal';

import {
  Wrapper,
  Header,
  Title,
  Content,
  Footer,
  Button,
  Box,
  Item,
  Action,
  Key,
  Name,
} from './AnnotationCanvasLegend.style';

const AnnotationCanvasLegendInner = ({ handleClose = () => {} }) => {
  const intl = useIntl();
  const theme = useTheme();

  return (
    <Wrapper theme={theme.annotationCanvasLegend.wrapper}>
      <Header theme={theme.annotationCanvasLegend.header}>
        <Title theme={theme.annotationCanvasLegend.title}>
          {intl.formatMessage({
            id: 'ANNOTATION_CANVAS_LEGEND.LEGEND',
          })}
        </Title>
      </Header>
      <Content>
        <Box>
          <Item>
            <Action>
              LMB |
              {intl.formatMessage({
                id: 'ANNOTATION_CANVAS_LEGEND.DOWN',
              })}
              | + |
              {intl.formatMessage({
                id: 'ANNOTATION_CANVAS_LEGEND.MOVE',
              })}
              |
            </Action>
            <Name>
              {intl.formatMessage({
                id:
                  'ANNOTATION_CANVAS_LEGEND.DRAW_NEW_OBJECT_FROM_POINT_TO_POINT',
              })}
            </Name>
          </Item>
          <Item>
            <Action>
              LMB |
              {intl.formatMessage({
                id: 'ANNOTATION_CANVAS_LEGEND.DOWN_ON_OBJECT',
              })}
              |
            </Action>
            <Name>
              {intl.formatMessage({
                id: 'ANNOTATION_CANVAS_LEGEND.SELECT_OBJECT',
              })}{' '}
              /{' '}
              {intl.formatMessage({
                id: 'ANNOTATION_CANVAS_LEGEND.UNSELECT_OBJECT',
              })}
            </Name>
          </Item>
          <Item>
            <Action>
              LMB |
              {intl.formatMessage({
                id: 'ANNOTATION_CANVAS_LEGEND.DOWN_ON_OBJECT',
              })}
              | + |
              {intl.formatMessage({
                id: 'ANNOTATION_CANVAS_LEGEND.MOVE',
              })}
              |
            </Action>
            <Name>
              {intl.formatMessage({
                id: 'ANNOTATION_CANVAS_LEGEND.MOVE_SELECTED_OBJECT',
              })}
            </Name>
          </Item>
          <Item>
            <Action>
              LMB |
              {intl.formatMessage({
                id: 'ANNOTATION_CANVAS_LEGEND.DOWN_ON_CORNER',
              })}
              | + |
              {intl.formatMessage({
                id: 'ANNOTATION_CANVAS_LEGEND.MOVE',
              })}
              |
            </Action>
            <Name>
              {intl.formatMessage({
                id: 'ANNOTATION_CANVAS_LEGEND.RESIZE_SELECTED_OBJECT',
              })}
            </Name>
          </Item>
          <Item>
            <Action>
              <Key theme={theme.annotationCanvasLegend.key}>DEL</Key>
            </Action>
            <Name>
              {intl.formatMessage({
                id: 'ANNOTATION_CANVAS_LEGEND.DELETE_SELECTED_OBJECT',
              })}
            </Name>
          </Item>
        </Box>
      </Content>
      <Footer>
        <Button
          type='button'
          theme={theme.button.alt}
          onClick={() => {
            handleClose();
          }}
        >
          {intl.formatMessage({ id: 'ANNOTATION_CANVAS_LEGEND.OK' })}
        </Button>
      </Footer>
    </Wrapper>
  );
};

const AnnotationCanvasLegend = ({ handleClose = () => {} }) => {
  return (
    <Modal handleClose={handleClose}>
      <AnnotationCanvasLegendInner handleClose={handleClose} />
    </Modal>
  );
};

AnnotationCanvasLegendInner.propTypes = {
  handleClose: PropTypes.func,
};

AnnotationCanvasLegend.propTypes = {
  handleClose: PropTypes.func,
};

export default AnnotationCanvasLegend;
